import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { HelperService } from "./helper.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { UserGeography } from "../../shared/models/user-geography.model";
import { API_ENDPOINTS } from "../../shared/constants/api-endpoints";

@Injectable({
    providedIn: 'root'
})
export class AuthorizationService extends BaseService {
    constructor(
        public override http: HttpClient, 
        private readonly helperService: HelperService
    ) {
        super(http);
    }

    public getGeographies(): Observable<Array<UserGeography>> {
        let url = this.helperService.prepareAPIURLBasedOnRegions();
        url = `${url}${API_ENDPOINTS.authorization}/me/geographies`;
        return this.baseGet<Array<UserGeography>>(url);
    }
}